const RTS_MACHINE_TRANSLATION = 'MACHINE_TRANSLATION';
const RTS_TRANSLATION_MEMORY = 'TRANSLATION_MEMORY';
const RTS_LLM = 'LLM';
const RTS_UNKNOWN = 'UNKNOWN';

export const getModelName = (matchType, modelName, translationEngine, llmModelId) => {
  if (!matchType) {
    return null;
  }

  const upper = matchType.toUpperCase();
  if (upper === RTS_TRANSLATION_MEMORY || upper === RTS_UNKNOWN) {
    return null;
  } else if (upper === RTS_MACHINE_TRANSLATION) {
    return modelName ? modelName : translationEngine;
  } else if (upper === RTS_LLM) {
    return llmModelId ? llmModelId : 'LLM';
  } else {
    return null;
  }
};

export const METRICS_CONTACT_ID_NOT_FOUND_MESSAGE =
  'Contact Id not found. If data for this contactId has been translated through RTS, please contact RTS team to troubleshoot the issue. Note that currently no metrics are collected for failed requests.';
export const LOGS_CONTACT_ID_NOT_FOUND_MESSAGE = 'Contact Id not found. ';
export const LOGS_CONTACT_DATA_FIELD_MISSING =
  'One or more contact data field is missing for the given contact Id. If data for this contactId has been translated through RTS, please contact RTS team to troubleshoot the issue. ';
